import { REDUX_ACTIONS } from "constants/constants";

const initialState = {
  name: "",
  primaryColor:"white",
  secondaryColor:"black",
  tertiaryColor:"white"
};

const clDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.FETCH_CL_DETAILS:
      return { ...state, ...action.payload,
         primaryColor:action.payload.primaryColor??"white",
         secondaryColor:action.payload.secondaryColor??"black",
         tertiaryColor:action.payload.tertiaryColor??"white"
        } ;
    case REDUX_ACTIONS.RESET_CL_DETAILS:
      return initialState;
    default:
      return state;
  }
};

export default clDetailsReducer;
